// Google Analytics 4 (GA4) Configuration
// Este arquivo gerencia a configuração e eventos do Google Analytics

// ID do Google Analytics - deve ser configurado via variável de ambiente
// Formato esperado: G-XXXXXXXXXX
// Pode ser configurado via REACT_APP_GA_MEASUREMENT_ID ou window.GA_MEASUREMENT_ID
const getGAId = () => {

  return 'G-21DKR676M3' || '';
};

const GA_MEASUREMENT_ID = getGAId();

/**
 * Inicializa o Google Analytics 4
 * Deve ser chamado uma vez quando a aplicação carrega
 */
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('Google Analytics: ID de medição não configurado. Configure REACT_APP_GA_MEASUREMENT_ID');
    return;
  }

  // Carrega o script do Google Analytics
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=G-21DKR676M3`;
  document.head.appendChild(script1);

  // Inicializa o gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
    send_page_view: true
  });

  console.log('Google Analytics inicializado:', GA_MEASUREMENT_ID);
};

/**
 * Rastreia uma visualização de página
 * @param {string} pagePath - Caminho da página
 * @param {string} pageTitle - Título da página
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

/**
 * Rastreia um evento personalizado
 * @param {string} eventName - Nome do evento
 * @param {object} eventParams - Parâmetros do evento
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Rastreia um download
 * @param {string} fileName - Nome do arquivo
 * @param {string} version - Versão do arquivo
 */
export const trackDownload = (fileName, version) => {
  trackEvent('download', {
    event_category: 'Downloads',
    event_label: `${fileName} ${version}`,
    value: 1
  });
};

/**
 * Rastreia um clique em botão CTA
 * @param {string} buttonName - Nome do botão
 * @param {string} location - Localização do botão na página
 */
export const trackCTA = (buttonName, location) => {
  trackEvent('cta_click', {
    event_category: 'Engagement',
    event_label: buttonName,
    location: location
  });
};

/**
 * Rastreia um clique em link externo
 * @param {string} url - URL do link
 * @param {string} linkText - Texto do link
 */
export const trackOutboundLink = (url, linkText) => {
  trackEvent('outbound_link', {
    event_category: 'Outbound Links',
    event_label: linkText,
    url: url
  });
};

/**
 * Rastreia um envio de formulário
 * @param {string} formName - Nome do formulário
 */
export const trackFormSubmit = (formName) => {
  trackEvent('form_submit', {
    event_category: 'Forms',
    event_label: formName
  });
};

/**
 * Rastreia um scroll até uma seção específica
 * @param {string} sectionName - Nome da seção
 */
export const trackScroll = (sectionName) => {
  trackEvent('scroll', {
    event_category: 'Engagement',
    event_label: sectionName
  });
};
